import React ,{ useEffect, useRef } 
from "react";
import { FormProvider, useForm } from "react-hook-form";

import CpntFormSectionContainer from "../../../components/forms/CpntFormSectionContainer";
import CpntFormSection from "../../../components/forms/CpntFormSection";
import TextInput from "../../../components/forms/TextInput";
import { validationMode } from "../../../config/helpers";
import { IFilterMarquesSearch, getDefaultFilterMarques } from "../../../models/interfaces/IFilterMarquesSearch";
import CpntFilterButtons from "../../../components/CpntFilterButtons";

interface IProps {
  filter?: IFilterMarquesSearch;
  changeFilter: (data: IFilterMarquesSearch) => void;
}

//Arrive pas a faire passer unb param au parent...
const CompteSocieteMarquesFilter: React.FC<IProps> = ({ filter, changeFilter }) => {

  const prevFilterRef = useRef<IFilterMarquesSearch | undefined>(filter);

  useEffect(() => {
    if (JSON.stringify(prevFilterRef.current) !== JSON.stringify(filter) || getValues() !== JSON.stringify(filter)) {
      reset(filter);
    }

    prevFilterRef.current = filter;
  }, [filter]);
  
  const formMethods = useForm<IFilterMarquesSearch>({
    defaultValues: getDefaultFilterMarques(),
  });

  const { handleSubmit, reset, getValues } = formMethods;

  const handleResetForm = () => {
    localStorage.removeItem("IFilterMarquesSearch");
    changeFilter(getDefaultFilterMarques());
    reset(getDefaultFilterMarques()); // Réinitialise explicitement le formulaire
  };

  const handleSubmitForm = () => {
    handleSubmit(onSubmit)();
  };

  const onSubmit = (data: IFilterMarquesSearch) => {
    changeFilter(data);
    localStorage.setItem("IFilterMarquesSearch",JSON.stringify(data)); //needed ??
  };

  const handleKeyPress = (e: { key: string; preventDefault: () => void; }) => {
    if (e.key === 'Enter') {
      //e.preventDefault();
      handleSubmit(onSubmit)();
      //SubmitButton.current.click();
    }
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)} onKeyDown={handleKeyPress} >
        <CpntFormSection pSectionLabel="Filtres">
          <CpntFormSectionContainer ColumnsSize={12} ColumnsSizesMd={[6, 6, 12]}>
            <TextInput
              label="Recherche"
              formName="SearchLibelle"
              validationStyle={validationMode.none}
              placeholder="Marque recherchée"
            />
            <div></div>
            <CpntFilterButtons  
              resetForm={handleResetForm}
              submitForm={handleSubmitForm}
            />
          </CpntFormSectionContainer>
        </CpntFormSection>
      </form>
    </FormProvider>
  );
};

export default CompteSocieteMarquesFilter;
